import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import PageAuth from "../pages/PageAuth/PageAuth";
import { isDev } from "../utils/dev";
import PageDashboard from "../pages/PageDashboard/PageDashBoard";
import PageEvents from "../pages/PageAllEvents/PageAllEvents";
import PageNewEvent from "../pages/PageEventCreate";
import PageEvent from "../pages/PageEvent/PageEvent";
import PageAction from "../pages/PageAction/PageAction";
import PageUsers from "../pages/PageUsers/PageUsers";
import PageThemes from "../pages/PageThemes/PageThemes";
import PageAuditTypes from "../pages/PageAuditTypes/PageAuditTypes";
import PageConstatGravities from "../pages/PageConstatGravities/PageConstatGravities";
import PageActionCreate from "../pages/PageActionCreate/PageActionCreate";
import PageEventEdit from "../pages/PageEventEdit/PageEventEdit";
import PageActionEdit from "../pages/PageActionEdit/PageActionEdit";
import PageExtraction from "../pages/PageExtraction/PageExtraction";
import PagePdcaConstat from "../pages/PagePdcaConstat/PagePdcaConstat";
import PagePdcaProjets from "../pages/PagePdcaProjets/PagePdcaProjets";
import PageAudits from "../pages/PageAudits/PageAudits";
import PageAuditCreate from "../pages/PageAuditCreate/PageAuditCreate";
import PageAudit from "../pages/PageAudit/PageAudit";
import PageAuditEdit from "../pages/PageAuditEdit/PageAuditEdit";
import PageConstatCreate from "../pages/PageConstatCreate/PageConstatCreate";
import PageConstat from "../pages/PageConstat/PageConstat";
import PageConstatEdit from "../pages/PageConstatEdit/PageConstatEdit";
import PageConstatActionCreate from "../pages/PageConstatActionCreate/PageConstatActionCreate";
import PageConstatActionEdit from "../pages/PageConstatActionEdit/PageConstatActionEdit";
import PageConstatAction from "../pages/PageConstatAction/PageConstatAction";
import PageProjectCreate from "../pages/PageProjectCreate/PageProjectCreate";
import PageProject from "../pages/PageProject/PageProject";
import PageProjectEdit from "../pages/PageProjectEdit/PageProjectEdit";
import PageProjectActionCreate from "../pages/PageProjectActionCreate/PageProjectActionCreate";
import PageProjectActionEdit from "../pages/PageProjectActionEdit/PageProjectActionEdit";
import PageProjectAction from "../pages/PageProjectAction/PageProjectAction";

type Props = {
  isAuthenticated: boolean;
  isAdmin: boolean;
  isPilote: boolean;
  isPerformer: boolean;
};

// Dev only
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const debugByPassAuth = isDev && true;

const Router: React.FC<Props> = ({
  isAuthenticated,
  isPilote,
  isAdmin,
  isPerformer,
}) => {
  // if (debugByPassAuth) {
  //   return (
  //     <BrowserRouter>
  //       <Routes>
  //         <Route path="/" element={<Authentication />} />
  //       </Routes>
  //     </BrowserRouter>
  //   );
  // }

  if (!isAuthenticated) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PageAuth />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    );
  }

  if (isPerformer) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PageDashboard />} />
          <Route path="/events/:eventId/actions/:id" element={<PageAction />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PageDashboard />} />
        <Route path="/events/new" element={<PageNewEvent />} />
        <Route path="/events" element={<PageEvents />} />
        <Route path="/events/:id" element={<PageEvent />} />
        <Route path="/pdca/constat" element={<PagePdcaConstat />} />
        <Route path="/pdca/projets" element={<PagePdcaProjets />} />
        <Route path="/audits" element={<PageAudits />} />
        <Route path="/audits/new" element={<PageAuditCreate />} />
        <Route path="/audits/:id" element={<PageAudit />} />
        <Route path="/audits/:id/edit" element={<PageAuditEdit />} />
        <Route path="/constats/new" element={<PageConstatCreate />} />
        <Route path="/constats/:id" element={<PageConstat />} />
        <Route
          path="/constats/:constatId/actions/new"
          element={<PageConstatActionCreate />}
        />
        <Route
          path="/constats/:constatId/actions/:id"
          element={<PageConstatAction />}
        />
        <Route path="/events/:eventId/actions/:id" element={<PageAction />} />
        <Route
          path="/events/:eventId/actions/new"
          element={<PageActionCreate />}
        />
        <Route path="/projects/new" element={<PageProjectCreate />} />
        <Route path="/projects/:id" element={<PageProject />} />
        <Route path="/projects/:id/edit" element={<PageProjectEdit />} />
        <Route
          path="/projects/:projectId/actions/new"
          element={<PageProjectActionCreate />}
        />
        <Route
          path="/projects/:projectId/actions/:id"
          element={<PageProjectAction />}
        />
        <Route
          path="/projects/:projectId/actions/:id/edit"
          element={<PageProjectActionEdit />}
        />
        {isPilote && (
          <>
            <Route
              path="/events/:eventId/actions/:id/edit"
              element={<PageActionEdit />}
            />
            <Route
              path="/constats/:constatId/actions/:id/edit"
              element={<PageConstatActionEdit />}
            />
          </>
        )}
        {isAdmin && (
          <>
            <Route path="/events/:id/edit" element={<PageEventEdit />} />
            <Route path="/constats/:id/edit" element={<PageConstatEdit />} />
            <Route path="/parametres/utilisateurs" element={<PageUsers />} />
            <Route path="/parametres/themes" element={<PageThemes />} />
            <Route path="/parametres/types-audit" element={<PageAuditTypes />} />
            <Route
              path="/parametres/gravite-constat"
              element={<PageConstatGravities />}
            />
            <Route path="/extraction" element={<PageExtraction />} />
          </>
        )}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
